import {Observable} from 'rxjs';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';

import Deposit from './model';

export const create = (institutionId, childId, billPayerId, deposit) =>
    Observable.fromPromise(
        RESTClient.postAuthenticated(`v2/deposits/${institutionId}/${childId}/${billPayerId}`, {
            deposits: [Deposit.toAPI(deposit)],
        }),
    ).map(response => Deposit.fromAPI(response.deposits[0]));

export const deleteDeposit = (institutionId, childId, deposit) =>
    Observable.fromPromise(
        RESTClient.deleteAuthenticated(`v2/deposits/${institutionId}/${childId}/${deposit.depositId}`),
    ).mapTo(deposit.depositId);

export const returnDeposit = (institutionId, childId, deposit) =>
    Observable.fromPromise(
        RESTClient.postAuthenticated(`v2/deposits/${institutionId}/${childId}/${deposit.depositId}/return`),
    ).map(response => Deposit.fromAPI(response.deposits[0]));

export const deleteDepositReturn = (institutionId, childId, deposit) =>
    Observable.fromPromise(
        RESTClient.deleteAuthenticated(`v2/deposits/${institutionId}/${childId}/${deposit.depositId}/return`),
    ).map(response => Deposit.fromAPI(response.deposits[0]));
